import { useQuery } from '@tanstack/react-query';
import type { PfPatientFormRecord } from '@elva/ui';
import { keys } from '@/api/queryKeys';
import { loadPatientFormReadSession } from '../api/patientFormReadApi';

function canLoadPatientFormDetail(form: PfPatientFormRecord | null | undefined): form is PfPatientFormRecord {
  if (!form) return false;
  return Boolean(
    form.submissionId?.trim() || form.accessToken?.trim() || form.assignmentId?.trim(),
  );
}

export function usePatientFormDetailSession(form: PfPatientFormRecord | null) {
  const submissionId = form?.submissionId?.trim() ?? '';
  const assignmentId = form?.assignmentId?.trim() ?? '';
  const accessToken = form?.accessToken?.trim() ?? '';
  return useQuery({
    queryKey: keys.forms.patientFormDetail(form?.id ?? '', submissionId || assignmentId || accessToken),
    queryFn: ({ signal }) => loadPatientFormReadSession(form!, { signal }),
    enabled: canLoadPatientFormDetail(form),
    staleTime: 60_000,
  });
}
